import * as React from 'react';
import debounce from 'lodash/debounce';

import { BREAK_POINTS } from '../../consts/style';

export const PhoneNoPhone = ({ width = BREAK_POINTS.MIN.SM, phone, noPhone }) => {
  const [aboveWidth, setAboveWidth] = React.useState(false);
  React.useEffect(() => {
    const updateAboveWidth = debounce(() => {
      const matches = window.matchMedia && window.matchMedia(`(min-width: ${width})`).matches;
      setAboveWidth(matches);
    }, 100);

    window.addEventListener('resize', updateAboveWidth);
    updateAboveWidth();

    return () => {
      window.removeEventListener('resize', updateAboveWidth);
    };
  }, []);

  return aboveWidth ? noPhone : phone;
};
